package waldo.sankan.lineamunicipalkmp.web.screens

import androidx.compose.foundation.layout.Spacer
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.semantics.error
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.CSSUnitValue
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.alignItems
import org.jetbrains.compose.web.css.backgroundColor
import org.jetbrains.compose.web.css.border
import org.jetbrains.compose.web.css.borderRadius
import org.jetbrains.compose.web.css.borderWidth
import org.jetbrains.compose.web.css.boxSizing
import org.jetbrains.compose.web.css.color
import org.jetbrains.compose.web.css.cursor
import org.jetbrains.compose.web.css.display
import org.jetbrains.compose.web.css.flex
import org.jetbrains.compose.web.css.flexDirection
import org.jetbrains.compose.web.css.flexWrap
import org.jetbrains.compose.web.css.fontSize
import org.jetbrains.compose.web.css.fontWeight
import org.jetbrains.compose.web.css.gap
import org.jetbrains.compose.web.css.height
import org.jetbrains.compose.web.css.justifyContent
import org.jetbrains.compose.web.css.letterSpacing
import org.jetbrains.compose.web.css.margin
import org.jetbrains.compose.web.css.marginBottom
import org.jetbrains.compose.web.css.marginRight
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.paddingTop
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.textAlign
import org.jetbrains.compose.web.css.width
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import waldo.sankan.lineamunicipalkmp.web.components.FilterDropdown
import waldo.sankan.lineamunicipalkmp.web.screens.AdminPanelUiState
import waldo.sankan.lineamunicipalkmp.web.screens.AdminPanelViewModel
import waldo.sankan.lineamunicipalkmp.web.screens.IncidentsTable
import kotlin.js.Date

@Composable
fun FilterSectionPanelDron(uiState: AdminPanelUiState, viewModel: AdminPanelViewModel, onBack: () -> Unit) {
    Div({
        style {
            display(DisplayStyle.Flex);
            flexDirection(FlexDirection.Row);
            gap(24.px);
            padding(12.px)
            border(1.px, LineStyle.Solid, Color("#cccccc"));
            borderRadius(8.px);
            marginBottom(24.px)
            alignItems(AlignItems.Center);
            flexWrap(FlexWrap.Wrap);
            fontSize(16.px);
            backgroundColor(Color("#f2f2f2"))
        }
    }) {
        FilterDropdown(
            label = "Mes:",
            selectedValue = uiState.filtroMes,
            options = uiState.mesesDisponibles,
            onValueChanged = { viewModel.onFiltroMesChanged(it) },
            optionDisplayNames = uiState.mesesDisponibles.associateWith {
                val (year, month) = it.split("-")
                Date(year.toInt(), month.toInt() - 1).toLocaleString("es-CL", options = js("{'month': 'long', 'year': 'numeric'}")).capitalize()
            }
        )


        FilterDropdown(
            label = "Tipo Incidencia:",
            selectedValue = uiState.filtroTipo,
            options = uiState.incidencias.mapNotNull { it.tipoIncidenciaDisplayName }.distinct().sorted(),
            onValueChanged = { viewModel.onFiltroTipoChanged(it) }
        )



        FilterDropdown(
            label = "Estado:",
            selectedValue = uiState.filtroEstado,
            options = listOf("EN_PROCESO", "SOLUCIONADO", "RECHAZADO", "VERIFICADO"),
            onValueChanged = { viewModel.onFiltroEstadoChanged(it) }
        )
        FilterDropdown(
            label = "Orden:",
            selectedValue = uiState.ordenPorFecha,
            options = listOf("Recientes", "Antiguas"),
            onValueChanged = { it?.let { viewModel.onOrdenChanged(it) } },
            isNullable = false
        )

        Div({ style { flex(1) } })

        // --- BOTÓN ESTRELLA: REPORTE MANUAL DRON ---
        Button(attrs = {
            onClick { viewModel.onShowIngresoIncidenciaClicked() }
            style {
                padding(10.px, 20.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                backgroundColor(Color("#34A853")); borderWidth(0.px); borderRadius(8.px); property("margin-right", "12.px")
            }
        }) { Text("+ Reportar Hallazgo") }

        Button(attrs = {
            onClick { viewModel.onShowMapClicked() }
            style {
                padding(10.px, 20.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                backgroundColor(Color("#1A73E8")); borderWidth(0.px); borderRadius(8.px);
                marginRight(12.px)
            }
        }) { Text("Mapa") }

        Button(attrs = {
            onClick { viewModel.onShowPlanCuadranteModal() }
            style {
                padding(10.px, 20.px); fontSize(14.px); fontWeight("bold"); color(Color.white)
                backgroundColor(Color("#1A73E8")); borderWidth(0.px); borderRadius(8.px);
                marginRight(12.px)
            }
        }) { Text("\uD83D\uDDFA\uFE0F Plan Cuadrante") }

        Button(attrs = {
            onClick { onBack() }
            style { padding(10.px, 20.px); fontSize(14.px); fontWeight("bold"); color(Color.white); backgroundColor(Color("#FB8C00")); borderWidth(0.px); borderRadius(8.px) }
        }) { Text("Volver al Panel") }
    }
}

@Composable
fun DroneVerificationScreen(
    viewModel: AdminPanelViewModel,
    onBack: () -> Unit
) {
    val uiState by viewModel.uiState.collectAsState()
    val incidenciasFiltradas by viewModel.incidenciasFiltradas.collectAsState()

    Div({
        style {
            display(DisplayStyle.Flex);
            width(100.percent);
            backgroundColor(Color("#1976D2"))
            property("border-bottom", "2px solid #1565C0")
        }
    }) {
        Div({
            style {
                width(10.percent); display(DisplayStyle.Flex); justifyContent(JustifyContent.Center)
                alignItems(AlignItems.Center); padding(24.px); boxSizing("border-box")
            }
        }) {
            Div({
                style {
                    display(DisplayStyle.Flex); flexDirection(FlexDirection.Column); alignItems(AlignItems.Center); gap(8.px) } }) {
                Img(src = "logo_icon.svg", attrs = { style { height(120.px) } })
                H2({
                    style { fontSize(24.px); color(Color.white); margin(0.px); property("text-shadow", "1px 1px 2px rgba(0,0,0,0.4)") } }) {
                    Span({ style { fontWeight("normal") } }) { Text("Linea") }
                    Span({ style { fontWeight("bold") } }) { Text("Muni") }
                }
                P(attrs = { attr("translate", "no"); style { fontSize(16.px); color(Color("#FB8C00")); fontWeight("bold"); letterSpacing(1.px); margin(0.px) } }) { Text("SMART CITY") }
            }
        }

        Div({
            style {
                width(90.percent); padding(8.px); display(DisplayStyle.Flex)
                flexDirection(FlexDirection.Column); gap(24.px); boxSizing("border-box")
            }
        }) {
            Div({
                style { display(DisplayStyle.Flex); justifyContent(JustifyContent.SpaceBetween); alignItems(AlignItems.Center); }
            }) {
                H1({
                    style {
                        color(Color.white); fontSize(32.px); fontWeight(700); paddingTop(20.px)
                        margin(0.px); flex(1); textAlign("center")
                    }
                }) { Text("PANEL VERIFICACION DRON") }
            }
            FilterSectionPanelDron(uiState = uiState, viewModel = viewModel, onBack = onBack)
        }
    }

    Div({
        style {
        padding(24.px)
  //      backgroundColor(Color("#1976D2"))
        backgroundColor(Color.white)
        property("border-bottom", "2px solid #1565C0")
        }
    }) {
        if (uiState.isLoading) {
            P { Text("Cargando lista de misiones...") }
        } else if (uiState.error != null) {
            P { Text("Error: ${uiState.error}") }
        } else {
            IncidentsTable(
                incidencias = incidenciasFiltradas,
                onIncidenciaClick = { viewModel.onDroneIncidenciaSelected(it) }
            )
        }
    }
}
